import React from 'react';
import { MessageCircle, Mail, ArrowRight, CheckCircle2 } from 'lucide-react';

export const FinalCTA = () => {
  return (
    <section className="py-16 md:py-20 bg-gradient-to-br from-[#003847] via-[#004555] to-[#003847] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#CFAE70]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#CFAE70]/10 rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#CFAE70]/20 border border-[#CFAE70]/30 rounded-full mb-8 backdrop-blur-sm">
            <span className="w-2 h-2 bg-[#CFAE70] rounded-full animate-pulse"></span>
            <span className="text-[#CFAE70] text-sm font-medium">Comienza hoy</span>
          </div>

          {/* Heading */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            Instala una máquina BOCADIA en tu espacio
          </h2>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-white/90 mb-12 leading-relaxed">
            Mejora la experiencia de las personas en tu espacio sin asumir inversión ni gestión operativa.
          </p>

          {/* Benefits Quick List */}
          <div className="flex flex-wrap justify-center gap-6 mb-12">
            {[
              'Sin inversión inicial',
              'Instalación gratuita',
              'Operación 100% gestionada',
              'Beneficio inmediato'
            ].map((benefit, index) => (
              <div key={index} className="flex items-center gap-2 text-white/95">
                <CheckCircle2 className="w-5 h-5 text-[#CFAE70]" />
                <span className="font-medium">{benefit}</span>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
            <a
              href="https://api.whatsapp.com/send/?phone=51992098884&text=Hola+me+interesa+instalar+una+maquina+en+uno+de+mis+espacios&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              className="group w-full sm:w-auto inline-flex items-center justify-center gap-3 px-10 py-5 bg-[#CFAE70] text-white font-bold text-lg rounded-xl hover:bg-[#B89A5F] transition-all duration-300 hover:scale-105 hover:shadow-2xl shadow-xl"
            >
              <MessageCircle className="w-6 h-6" />
              Escribe al WhatsApp
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </a>

            <a
              href="mailto:soportebocadia@outlook.com?subject=Quiero%20instalar%20una%20maquina%20en%20mis%20espacios&body=Hola%20me%20interesa%20instalar%20una%20maquina%20en%20uno%20de%20mis%20espacios.%20Por%20favor%20te%20dejo%20mis%20datos%20para%20que%20me%20envies%20toda%20la%20informacion%20necesaria."
              className="group w-full sm:w-auto inline-flex items-center justify-center gap-3 px-10 py-5 bg-white/10 backdrop-blur-sm text-white font-bold text-lg rounded-xl hover:bg-white/20 transition-all duration-300 border-2 border-white/30"
            >
              <Mail className="w-6 h-6" />
              Contacto por correo
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
          <path d="M0 0L60 10C120 20 240 40 360 46.7C480 53 600 47 720 43.3C840 40 960 40 1080 46.7C1200 53 1320 67 1380 73.3L1440 80V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0V0Z" fill="#F8F5F0"/>
        </svg>
      </div>
    </section>
  );
};
